export const INITIAL_DELAY = 500
export const POLLING_DELAY = 2000
